
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"1.25","y":"1.25","width":"17.5","height":"17.5","rx":"8.75","fill":"#007AFF","stroke":"#fff","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M10.257 5.184l.963 2.854 3.012.035a.27.27 0 01.158.488l-2.416 1.798.898 2.875a.27.27 0 01-.415.301L10 11.793l-2.457 1.742a.27.27 0 01-.415-.302l.898-2.875L5.61 8.56a.27.27 0 01.158-.488l3.012-.034.963-2.854a.27.27 0 01.514 0z","fill":"#fff"}})])
          )
        }
      }
    